module.exports = __webpack_public_path__ + "img/387.3bd6888c.jpg";